module.exports = require('./src/Scripts/jquery.fileDownload');



//////////////////
// WEBPACK FOOTER
// ./~/jquery-file-download/index.js
// module id = 413
// module chunks = 0